import { RadioGroup } from '@zoopla-eng/zds/radio-group';
import { queries } from '@zoopla-eng/zds/themes';
import { useBreakpointListener } from '@zoopla/dom-util';

export type FurnishedState =
    | ''
    | 'furnished'
    | 'part_furnished'
    | 'unfurnished';

type FurnishingProps = {
    value: FurnishedState;
    onChange: (furnishedState: FurnishedState) => void;
};

export const Furnishing = ({ value, onChange }: FurnishingProps) => {
    const bisect = useBreakpointListener(queries.M[100], 'GT');

    return (
        <RadioGroup
            id="furnishing"
            bisect={bisect}
            label="Furnishing"
            value={value}
            items={[
                {
                    id: 'any',
                    value: '',
                    label: 'Any'
                },
                {
                    id: 'furnished',
                    value: 'furnished',
                    label: 'Furnished'
                },
                {
                    id: 'part_furnished',
                    value: 'part_furnished',
                    label: 'Part furnished'
                },
                {
                    id: 'unfurnished',
                    value: 'unfurnished',
                    label: 'Unfurnished'
                }
            ]}
            onValueChange={onChange}
        />
    );
};
